<template>
  <!-- 询问是否删除开始 -->
  <div class="BlockList-W">
    <div class="BlockList2">
      <div class="delet">
        <div class="box">
          <div class="deletit">Confirm the Release of Ownership</div>
          <div class="delflex">
            <div class="deleterr" @click="Cancel">Cancel</div>
            <div class="deletok" @click="Confirm">Confirm</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 询问是否删除结束 -->
</template>

<script>
import { activateUser } from "@/assets/server/api";
import axios from "axios";
export default {
  props: ["contractAddress"],
  data() {
    return {
      url: "https://explorer.tfsc.io/tfscBrowser/user/",
     // url: "http://192.168.1.123:9200/tfscBrowser/user/",
      Address: "",
      flag: false,
      userId: "",
      jwtToken: "",
    };
  },
  components: {},
  created() {},
  mounted() {
    this.userId = localStorage.getItem("userId");
    this.jwtToken = localStorage.getItem("jwtToken");
    // this.BlockList();
  },
  watch: {
    deep: true,
    contractAddress(val) {
      this.Address = val;
    //  console.log(this.Address);
    },
  },
  methods: {
    Cancel() {
      this.flag = false;
      this.$emit("delflog", this.flag);
    },
    Confirm() {
     // console.log("删除");
      const params = {
        userId: this.userId,
        contractAddress: this.Address,
      };
   //   console.log(params);
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      let config = {
        headers: {
          "Content-Type": "application/json",
          jwtToken: this.jwtToken,
        },
      }; //修改请求头

      // let url = "https://explorer.tfsc.io/ttosServer/activity/inviteRanks";
      let url = this.url + "removeContractVerify";
      axios
        .post(url, formData, config)
        .then((res) => {
    //      console.log(res.data.result);

          if (res.data.code == 200) {
      //      console.log("删除成功");
            this.flag = false;
            this.$emit("delflog", this.flag);
            //this.lists = res.data.result.list;
            // console.log(this.lists);
          } else if (res.data.code == 401) {
      //      console.log("进行了异地登录1111");

            localStorage.removeItem("userId");
            localStorage.removeItem("email");
            localStorage.removeItem("jwtToken"); //  this.$message(res.data.result); //this.signout();
            this.$message("Please log in again666");
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        //  console.log(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.BlockList2 {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  // height: 1000px !important;
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  overflow: auto;
  // 删除开始
  .delet {
    width: 401px;
    height: 173px;
    background: #13161b;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    position: absolute;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .box {
      width: 320px;
      margin: 0 auto;
      .deletit {
        height: 33px;
        font-size: 20px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #ffffff;
        line-height: 33px;
        word-spacing: -2px;
        margin-top: 36px;
      }
      .delflex {
        display: flex;
        margin-top: 36px;
        //  border: 1px solid red;
        .deleterr {
          width: 134px;
          height: 44px;
          line-height: 44px;
          font-size: 16px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #04bf83;
          text-align: center;
          cursor: pointer;
          margin-left: 56px;
        }
        .deletok {
          width: 134px;
          height: 44px;
          line-height: 44px;
          background: rgba(2, 210, 142, 0.9);
          border-radius: 10px 10px 10px 10px;
          opacity: 1;
          text-align: center;
          font-size: 16px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #13161b;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
